var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventsAndConference(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6V26H6V10H40V26H44V6H2ZM13.6328 24C11.6484 24 10 25.6484 10 27.6328V30H7.63281C5.64837 30 4 31.6484 4 33.6328V42H16V36H18V42H30V36H32V42H44V33.6328C44 31.6484 42.3512 30 40.3672 30H36V27.6328C36 25.6484 34.3512 24 32.3672 24H27.6328C25.6484 24 24 25.6484 24 27.6328V30H22V27.6328C22 25.6484 20.3512 24 18.3672 24H13.6328ZM14 28H18V32H15.5859C15.2349 31.3189 14.6809 30.7653 14 30.4141V28ZM28 28H32V32H29.5859C29.2349 31.3189 28.6809 30.7653 28 30.4141V28ZM8 34H12V38H8V34ZM22 34H26V38H22V36V34ZM36 34H40V38H36V36V34Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsAndConference);
export default __webpack_public_path__ + "static/media/events-and-conference.72f2350b717515b21008bd4065cab692.svg";
export { ForwardRef as ReactComponent };